import React, { Component } from 'react';
import './style.css';
import { HeaderQuestion, NextQuestionButton } from '../../components';
import ImageOrText from './imageortext';
import { Trans, translate } from 'react-i18next';

class Comparison extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    this.setState({ value: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
  }

  render() {
    const { t } = this.props;
    const name1 = this.props.pair.projectObjects[0].name;
    const name2 = this.props.pair.projectObjects[1].name;
    const description = (
      <Trans i18nKey="comparisonDescription">
        Are "{{ name1 }}" and "{{ name2 }}" for you personally different or
        similar?
      </Trans>
    );

    return (
      <div className="card-body">
        <form onSubmit={this.handleSubmit}>
          <HeaderQuestion
            description={description}
            text={t('Just follow your intuition.')}
            skip={this.props.skip}
            pairId={this.props.pair.pairId}
          />
          <div className="App-comparison-text-center">
            <ImageOrText
              image={this.props.pair.projectObjects[0].image}
              name={this.props.pair.projectObjects[0].name}
            />
            <ImageOrText
              image={this.props.pair.projectObjects[1].image}
              name={this.props.pair.projectObjects[1].name}
            />
          </div>
          <NextQuestionButton
            to={this.props.url + '/similar'}
            text={t('SIMILAR')}
            autoFocus={true}
          />
          <NextQuestionButton
            to={this.props.url + '/different'}
            text={t('DIFFERENT')}
          />
        </form>
      </div>
    );
  }
}

export default translate('translations')(Comparison);



// WEBPACK FOOTER //
// ./src/comparison/components/Pair/comparison.js